export default {
  settings: {
    languageId: 'en',
  },
  labels: {
    en: {
      'scheduler.modal.title.create': 'Create Feed',
      'scheduler.modal.title.edit': 'Edit Feed',
      'scheduler.modal.description':
        "Set up custom feeds in Morningstar Direct. You can test them in the Feed Manager's tab before scheduling.",
      'scheduler.modal.description.lens':
        'Set up custom feeds in Morningstar Lens. You can test them in the Data Feeds page before scheduling.',
      'scheduler.modal.source.step': 'Source',
      'scheduler.modal.parameters.step': 'Parameters',
      'scheduler.modal.format.step': 'Format',
      'scheduler.modal.delivery.step': 'Delivery',
      'scheduler.modal.cancel.button': 'Cancel',
      'scheduler.modal.next.button': 'Next',
      'scheduler.modal.back.button': 'Back',
      'scheduler.modal.save.button': 'Save Feed',
      'scheduler.modal.edit.button': 'Update Feed',
      'scheduler.modal.saveandschedule.button': 'Save and Schedule Feed',
      'scheduler.modal.editandschedule.button': 'Update and Schedule Feed',
      'scheduler.modal.source.name.label': 'Feed Name',
      'scheduler.modal.source.name.placeholder': 'Enter Name',
      'scheduler.modal.duplicate.name.error':
        'Feed name already exists. Please use a different name.',
      'scheduler.modal.empty.name.error': 'Please enter a name.',
      'scheduler.modal.overflow.name.error':
        'The name may not be longer than 200 characters.',
      'scheduler.modal.underflow.name.error':
        'The name should have at least 4 characters.',
      'scheduler.modal.invalid.name.error':
        'The name can only include letters, numbers and the following special characters: ., _, (, ), -, &, <, >, ", \', #, $, %, =, :, @, |.',
      'scheduler.modal.source.type.label': 'Source Type',
      'scheduler.modal.source.investment.list': 'Investment List',
      'scheduler.modal.source.performance.report': 'Performance Report',
      'scheduler.modal.source.search.criteria': 'Search Criteria',
      'scheduler.modal.data.set.type.label': 'Data Set Type',
      'scheduler.modal.parameters.dataset.holdings.view.label':
        'Portfolio View',
      'scheduler.modal.parameters.dataset.holdings.number.label':
        'Number of Holdings',
      'scheduler.modal.parameters.dataset.holdings.frequency.label':
        'Portfolio Frequency',
      'scheduler.modal.parameters.performance.report.label':
        'Performance Report',
      'scheduler.modal.parameters.investment.item.label': 'Investment Item',
      'scheduler.modal.parameters.investment.item.error':
        'You do not have any investment to select.',
      'scheduler.modal.parameters.data.set.label': 'Data Set',
      'scheduler.modal.parameters.userdatasets.label': 'Your Data Sets',
      'scheduler.modal.parameters.userlists.label': 'Your Lists',
      'scheduler.modal.parameters.usersearch.label': 'Your Search Criteria',
      'scheduler.modal.parameters.morningstardatasets.label':
        'Morningstar Data Sets',
      'scheduler.modal.parameters.morningstarlists.label': 'Morningstar Lists',
      'scheduler.modal.parameters.morningstarsearch.label':
        'Morningstar Search Criteria',
      'scheduler.modal.delivery.type.label': 'Delivery Type',
      'scheduler.modal.performanceReport.label': 'Performance Report',
      'scheduler.modal.performanceReport.error':
        'You do not have any performance reports to select.',
      'scheduler.modal.performanceReport.morningstar':
        'Morningstar Performance Reports',
      'scheduler.modal.performanceReport.user': 'Your Performance Reports',
      'scheduler.modal.delivery.destination.label': 'Delivery Destination',
      'scheduler.modal.format.emptystate.title': 'No Format Settings Available',
      'scheduler.modal.format.emptystate.message': `The machine readable format for a Performance Report may not be suitable for all types of reports. 
        We recommend that you test the output before scheduling your feed. We are working to progressively improve the format and any feedback is valuable to us. 
        If there are any issues, you can either create a batch in Performance Reporting instead or contact customer support for more information.`,
      'scheduler.modal.delivery.email.placeholder': 'Enter an Email',
      'scheduler.modal.delivery.empty.email.error':
        'Please add an email address.',
      'scheduler.modal.delivery.multiple.email.error':
        'The delivery is available only for a single email',
      'scheduler.modal.delivery.ftp.error':
        'Please contact your Morningstar Customer Support team to enable the FTP delivery feature.',
      'scheduler.modal.delivery.invalid.email.error':
        'Please check for typos or missed information.',
      'scheduler.modal.delivery.attestation.title': 'Confirm Data Distribution',
      'scheduler.modal.delivery.attestation.button': 'View License Agreement',
      'scheduler.modal.delivery.attestation.text.confirm':
        'I confirm I have reviewed Section 2.1 of the Direct license agreement and my use of this data complies with Morningstar terms for generating and distributing Direct Product Output to internal and external parties.',
      'scheduler.modal.delivery.attestation.text.limited.confirm':
        'If you proceed without confirming, your Direct data feed will be limited to 25 rows. To increase this data limit, you must confirm the data agreement above.',
      'scheduler.modal.saveFeed.success.title': 'Feed Saved',
      'scheduler.modal.saveFeed.success.message':
        "You can now access this feed from the Feed Manager's tab.",
      'scheduler.modal.saveFeed.success.message.lens':
        'You can now access this feed from the Data Feeds page.',
      'scheduler.modal.saveSchedule.success.title': 'Schedule Saved',
      'scheduler.modal.saveSchedule.success.message':
        'The feed has been scheduled. You can monitor its progress by checking the Schedules tab in the Feed Manager.',
      'scheduler.modal.saveSchedule.success.message.lens':
        'The feed has been scheduled. You can monitor its progress by checking the Schedules section in the Data Feeds page.',
      'scheduler.modal.save.success.ok.button': 'Ok',
      'scheduler.modal.save.success.redirect.button': 'Go to feed details',
      'scheduler.modal.save.failure.title': 'Saving Failed',
      'scheduler.modal.save.failure.message':
        'Feed not successfully saved due to an error.',
      'scheduler.modal.error.response.title': 'Feed parameters not available',
      'scheduler.modal.error.response.message':
        'It appears that the requested feed parameters encountered an issue.',
      'scheduler.modal.save.duplicateFeed.title': 'Duplicate Feed Name',
      'scheduler.modal.save.duplicateFeed.message':
        'The feed you want to create can not have the same name as your other feeds.',
      'scheduler.modal.save.duplicateSchedule.title': 'Duplicate Schedule Name',
      'scheduler.modal.save.duplicateSchedule.message':
        'The schedule you want to create can not have the same name as your other schedules.',
      'scheduler.modal.error.response.retry.button': 'Retry',
      'scheduler.modal.save.failure.tryagain.button': 'Try Again',
      'scheduler.modal.save.failure.duplicate.button': 'Change name',
      'scheduler.modal.save.failure.cancel.button': 'Cancel',
      'scheduler.modal.3rdparty.description':
        '*We are working to expand support for 3rd party data in feeds. Unsupported data may be omitted.',
      'scheduler.input.loading': 'Loading data...',
      'scheduler.modal.source.custom.data.set.basic': 'Basic',
      'scheduler.modal.source.custom.data.set.holdings': 'Holdings',
    },
  },
}
